import { createSelector } from 'reselect';

import decodeChallengeEntrySelection from '../normalizers/decodeChallengeEntrySelection';

const selectionSelector = createSelector(
  state => state.compatibleChallenges.lineup.selection,
  decodeChallengeEntrySelection
);

export default selectionSelector;
